import React, { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { ShieldAlert } from 'lucide-react';

export const SecurityGuard = ({ children }: { children: React.ReactNode }) => {
  const [isBanned, setIsBanned] = useState<boolean | null>(null);

  useEffect(() => {
    const checkSecurity = async () => {
      try {
        // 1. Fetch Client IP Address
        const res = await fetch('https://api.ipify.org?format=json');
        const data = await res.json();
        const clientIp = data.ip;

        if (!clientIp) {
          setIsBanned(false);
          return;
        }

        // 2. Check against banned_ips table
        const { data: banData, error } = await supabase
          .from('banned_ips' as any)
          .select('ip_address')
          .eq('ip_address', clientIp)
          .maybeSingle();

        if (banData && !error) {
          setIsBanned(true); // Direct Match! Drop connection.
        } else {
          setIsBanned(false);
        }

      } catch (err) {
        // Fail open if ipify is blocked or down, so we don't accidentally lock out legitimate traffic
        setIsBanned(false);
      }
    };

    checkSecurity();
  }, []);

  // Ensure the security check runs entirely in the background without blocking the initial application hydration/skeleton load.

  // Render the permanent ban screen
  if (isBanned === true) {
    return (
      <div className="min-h-screen w-full flex flex-col items-center justify-center bg-slate-950 text-slate-50 p-6 selection:bg-red-500/30">
        <div className="max-w-md w-full text-center space-y-6">
          <div className="h-24 w-24 bg-red-500/10 rounded-full flex items-center justify-center mx-auto border border-red-500/20 shadow-[0_0_100px_rgba(239,68,68,0.2)]">
            <ShieldAlert className="h-10 w-10 text-red-500" />
          </div>
          <div className="space-y-2">
            <h1 className="text-3xl font-black tracking-tight text-white">Access Denied</h1>
            <p className="text-slate-400">
              Your connection has been forcibly blocked by the Make Me Filer security firewall due to suspicious network activity.
            </p>
          </div>
          <div className="pt-4 border-t border-slate-800">
            <p className="text-xs font-mono text-slate-500">
              ERR_NETWORK_BLACKLISTED<br/>
              If you believe this is an error, please contact system administration.
            </p>
          </div>
        </div>
      </div>
    );
  }

  // Safe to render
  return <>{children}</>;
};
